export const GROUP_TO_WAY = 'orders-groups-change-way/GROUP_TO_WAY';
export const groupToWayAction = payload => ({
	type: GROUP_TO_WAY,
	payload,
});

export const WAY_TO_WAY = 'orders-groups-change-way/WAY_TO_WAY';
export const wayToWayAction = payload => ({
	type: WAY_TO_WAY,
	payload,
});

export const ORDER_GROUP_TO_WAY = 'orders-groups-change-way/ORDER_GROUP_TO_WAY';
export const orderGroupToWayAction = payload => ({
	type: ORDER_GROUP_TO_WAY,
	payload,
});

export const ORDER_WAY_TO_WAY = 'orders-groups-change-way/ORDER_WAY_TO_WAY';
export const orderWayToWayAction = payload => ({
	type: ORDER_WAY_TO_WAY,
	payload,
});
